import React, { useState, forwardRef } from "react"
import {
  FieldProps,
  useFocusRing,
  LabelBlock,
  COLORS,
} from "./WooNotesControlsCommon"

export const WooNotesPasswordInput = forwardRef<HTMLInputElement, FieldProps>(
  (props, ref) => {
    const { label, helperText, errorText, style, ...rest } = props
    const ring = useFocusRing()
    const [show, setShow] = useState(false)

    return (
      <LabelBlock label={label} helperText={helperText} errorText={errorText}>
        <div style={{ position: "relative", width: "100%" }}>
          <input
            ref={ref}
            {...rest}
            {...ring}
            type={show ? "text" : "password"}
            style={{
              width: "100%",
              padding: "12px 52px 12px 14px",
              borderRadius: 14,
              border: `2px solid ${errorText ? COLORS.danger : COLORS.dark}`,
              background: COLORS.bg,
              color: COLORS.text,
              outline: "none",
              fontSize: 16,
              fontWeight: 700,

              boxShadow: ring.focused
                ? `0 0 0 5px ${COLORS.ring}, 0 6px 0 ${COLORS.dark}`
                : `0 6px 0 ${COLORS.dark}, 0 10px 18px rgba(14, 74, 44, 0.10)`,

              transition:
                "box-shadow 120ms ease, transform 120ms ease, border 120ms ease",
              ...style,
            }}
          />

          <button
            type="button"
            onClick={() => setShow((s) => !s)}
            style={{
              position: "absolute",
              height: "70%",
              right: 10,
              top: "48%",
              transform: "translateY(-50%)",
              padding: "0px 10px",
              borderRadius: 12,
              border: `2px solid ${COLORS.dark}`,
              background: `linear-gradient(180deg, ${COLORS.g1} 0%, ${COLORS.g2} 60%, ${COLORS.g3} 100%)`,
              color: COLORS.white,
              fontWeight: 900,
              cursor: "pointer",
              boxShadow: `0 4px 0 ${COLORS.dark}`,
            }}
            aria-label={show ? "Hide password" : "Show password"}
          >
            {show ? "Hide" : "Show"}
          </button>
        </div>
      </LabelBlock>
    )
  }
)

WooNotesPasswordInput.displayName = "WooNotesPasswordInput"
